import React, {useState, useEffect} from 'react'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { get } from '../../../lib/api'
import { Text,Box } from '../../../designSystem'
import { dummy_entity_id_for_all_book } from './constants'
import { useInfiniteScroll } from '../../../lib/customHooks'
import Loader from '../../../components/Loader'
import { card } from './style'
dayjs.extend(customParseFormat)

const BalanceHistory = ({walletDetails, bookSelected, payoutTabSelected, ...props}) => {
  const [trxnArr, setTrxnArr] = useState([])
  const [isLoading,setIsLoading] = useState(false)
  const [nextUrl, setNextUrl] = useState(null)
  
  useEffect(() => {
    fetchBalanceHistory()
  }, [bookSelected,payoutTabSelected,walletDetails])

  const fetchMoreBalanceHistory = (setIsFetching) =>{
    if (!nextUrl) {
      setIsFetching(false)
      return
    }
    get(nextUrl).then(response => {
      setIsFetching(false)
      const { result, next_url } = response
      setTrxnArr((prevArr) =>prevArr.concat(result))
      setNextUrl(next_url)
    })

  }

  const isFetching = useInfiniteScroll(fetchMoreBalanceHistory)
  const fetchBalanceHistory = () => {
    const {wallet_id} = walletDetails
    let qString = `page_no=1&page_size=10`
    if(bookSelected !== dummy_entity_id_for_all_book){
      qString += `&book_id=${bookSelected}`
    }
    if (wallet_id) {
    setIsLoading(true)
      get(`/content_api/book.get_rewards?wallet_id=${wallet_id}&${qString}&time_period=${payoutTabSelected}&is_novel=1`).then(response => {
        setIsLoading(false)
        const { result, next_url } = response
        setTrxnArr(result)
        setNextUrl(next_url)
      }).catch(() => setIsLoading(false))
    }
  }

  const isMobile = window.screen.width < 600
  if(isLoading) return <Loader/>
  return (
    <>
     {!isMobile && 
        <Box {...card}>
            <Text variant="titleSecondary" fontWeight="r">Description</Text>
            <Text variant="titleSecondary" fontWeight="r" ml="auto" textAlign="right" >Amount</Text>
            {/* <Text variant="titleSecondary" fontWeight="r" ml={30} mr={10} textAlign="right" >Balance</Text> */}
        </Box>
      }
      {trxnArr.map(({ create_time, description, debit, credit, book_name }, i) => {
        return (
           <Box variant="flex" bg='surface.foreground' flexDirection="row" p={16} my={4} key={`transaction-entry-${i}`}>
            <Box variant="flex" flexDirection="column">
              <Text variant="title" fontWeight="r">{description}</Text>
              {book_name && <Text variant="smallText">{book_name }</Text>}
              <Text variant="subtext" textAlign="left">{dayjs(create_time).format('DD MMM YYYY')}</Text>
            </Box>
            <Box variant="flex" flexDirection="row">
              <Text fontWeight="s" mr={10} color={debit ? '#dd3623' : '#79ba10'}>{`${debit ? '-' : '+'} ${walletDetails?.currency === 'USD' ? '$' : '₹'}${credit || debit}`}</Text>
              {/* {!isMobile && <Text fontWeight="s" width={80}>{balance}</Text>} */}
            </Box>
          </Box>
        )
      })}
      {isFetching && <Loader />}
    </>
  )
}

export default BalanceHistory
